<div>
  <span [attr.data-test-id]="'status-verified-' + rowIndex + '-' + cellIndex" *ngIf="tableRowData.manage.status">
    {{ 'TABLE_VERIFIED' | translate }}
  </span>
  <span
    [attr.data-test-id]="'status-not-verified-' + rowIndex + '-' + cellIndex"
    class="dotted-text"
    *ngIf="!tableRowData.manage.status && tableRowData.manage.status != null"
  >
    {{ 'TABLE_REJECTED' | translate }}
    <span
      class="icon"
      placement="top"
      [attr.data-test-id]="'tooltip-open-' + rowIndex + '-' + cellIndex"
      [ngbTooltip]="tipContent"
    >
      ?
    </span>
    <ng-template #tipContent>
      {{ tableRowData.manage.reason }}
    </ng-template>
  </span>
  <div *ngIf="tableRowData.manage.status == null" class="action-holder align-self-center my-1">
    <button
      appLongOperation
      operation-managed-control
      type="button"
      [disabled]="deactivated && !tableRowData.accessForAdmin"
      [attr.data-test-id]="buildActionButtonTestId(CellActionTypes.CONFIRM)"
      [ngbTooltip]="tooltipDescription(CellActionTypes.CONFIRM) | translate"
      (click)="confirm()"
      class="btn btn-link me-3"
    >
      <svg-icon src="assets/icons/icon-check.svg" class="icon-check"></svg-icon>
    </button>
    <button
      operation-managed-control
      type="button"
      [attr.data-test-id]="buildActionButtonTestId(CellActionTypes.REJECT)"
      [ngbTooltip]="tooltipDescription(CellActionTypes.REJECT) | translate"
      (click)="reject()"
      class="btn btn-link"
    >
      <svg-icon src="assets/icons/icon-cross.svg" class="icon-cross"></svg-icon>
    </button>
  </div>
</div>
